import { NotesModel } from 'one-card-notes-history';

import {
    ADD,
    SET,
    REINIT,
    DISABLE_ADD,
    SET_STATUS
} from './types';

import {
    Actions,
} from './actions';

/**
 *
 * @param context contains settings.json etc
 * @param initial initial state if set
 */
export const notesHistory = (
    context: any,
    initial?: NotesModel,
) => {
    let initialstate: NotesModel = initial || { notes: [], error: undefined, disableAdd: false, epicChecked: false, status: 0 };
        return (
        state: NotesModel,
        action: Actions,
    ) => {
        const {
            type,
            payload,
        } = action;
        let updated = state || initialstate;

        switch (type) {
            case SET:
                updated = {
                    ...payload,
                }
                break;
            case ADD:
                updated = {
                    ...updated,
                    notes: [
                        ...(payload.notes ?? []),
                        ...(updated.notes ?? []) 
                    ],
                    error: payload.error 
                };
                break;
            case DISABLE_ADD: 
                updated = {
                    ...updated,
                    disableAdd: payload
                };
                break;
            case SET_STATUS:
                    updated = {
                        ...updated,
                        status: payload
                    };
                    break;
            case REINIT:
                updated = {
                    ...initialstate
                }
                break;
        }
        return updated;
    }
};
